// Человекочитаемое название дебюта для карточки партии.
// Chess.com отдаёт ECOUrl (…/openings/Kings-Fianchetto-Opening) вместо имени —
// достаём слаг и раздекодируем. У Lichess есть готовое opening.name.
import { pgnTag, type CoachGame } from '@ext/core/game-sources';

/** «…/openings/Kings-Fianchetto-Opening-1...d5-2.c4» → «Kings Fianchetto Opening». */
export function humanizeOpeningSlug(raw: string): string {
  const afterOpenings = raw.split('/openings/').pop() || raw;
  let name = afterOpenings;
  try {
    name = decodeURIComponent(afterOpenings);
  } catch {
    /* оставляем как есть, если это не валидный %-энкод */
  }
  name = name.replace(/-/g, ' ').trim();
  // отрезаем хвост с номерами ходов («… 2.c4», «… 1...d5»)
  name = name.replace(/\s+\d+\.{1,3}.*$/, '').trim();
  return name.replace(/\s+/g, ' ');
}

function isUrlish(v: string): boolean {
  return /https?:\/\//.test(v) || v.includes('/openings/');
}

/** Название дебюта партии: имя как есть, либо расшифрованный ECOUrl, либо пусто. */
export function openingLabel(game: Pick<CoachGame, 'opening' | 'pgn'>): string {
  const name = String(game.opening?.name || '').trim();
  if (name && !isUrlish(name)) return name;
  const url = isUrlish(name) ? name : pgnTag(game.pgn || '', 'ECOUrl');
  if (url && isUrlish(url)) return humanizeOpeningSlug(url);
  return name;
}
